export default __webpack_public_path__ + "static/media/name_logo.b8885b8c.png";